import request from '@/api/request'

export function createOrder(data) {
  return request({
    url: '/pay',
    method: 'post',
    data: data
  });
}

export function queryOrder(data) {
  return request({
    url: `/pay?orderid=${data}`,
    method: 'get'
  });
}


// WEBPACK FOOTER //
// ./src/api/payment.js